<template>
  <div class="wrapper-detail">
    <!-- 会员信息卡片 -->
    <el-card class="member-card" shadow="never">
      <MemberInfo :detailInfo="detailInfo" @updateDetail="getEmitReviewOrderDetail" />
    </el-card>

    <!-- 标签页和内容区域 -->
    <el-card class="content-card" shadow="never">
      <el-tabs v-model="activeName" class="detail-tabs">
        <el-tab-pane name="1">
          <span slot="label">
            <i class="el-icon-document"></i>
            <span>订单资料</span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            <i class="el-icon-view"></i>
            <span>审核数据</span>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="tab-content">
        <!-- 基础信息 -->
        <DetailBase
          ref="base"
          v-show="activeName == 1"
          @updateDetail="getReviewOrderDetail"
          @goJS="goJS"
        />

        <!-- 信用数据 -->
        <DetailJiShen
          ref="jishen"
          v-show="activeName == 2"
        />
      </div>
    </el-card>

    <!-- 审核结果 -->
    <div class="result">
      <AuditResult
        @result="handleResult"
        :detailInfo="detailInfo"
        :orderScoreProfile="detailInfo.orderScoreProfile || {}"
      />
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <!-- 通过 -->
      <div v-show="result == 1" class="dialog-content">
        <div class="item">
          <div class="tips">审核 <span class="my-waring">通过</span></div>
        </div>
        <div class="item">
          <span>备注：</span>
          <span>
            <el-input
              v-model="reviewPass"
              rows="5"
              type="textarea"
              placeholder="请输入备注"
            />
          </span>
        </div>
        <div class="item" v-if="tip">
          <span></span>
          <span class="tip">
            <i class="el-icon-warning"></i>
            该用户与<span style="font-weight: 700; color: #000">{{ tip }}</span>库中数据匹配，请复核后谨慎操作！
          </span>
        </div>
      </div>

      <!-- 拒绝 -->
      <div v-show="result == 2" class="dialog-content">
        <div class="tips">审核 <span class="my-waring">拒绝</span> ，请输拒绝入原因</div>
        <el-input
          v-model="content"
          rows="5"
          type="textarea"
          placeholder=""
        />
        <div class="tip-hit" v-if="tip">
          <span class="tip">
            <i class="el-icon-warning"></i>
            该用户与<span style="font-weight: 700; color: #000">{{ tip }}</span>库中数据匹配，请复核后谨慎操作！
          </span>
        </div>
      </div>
<!--      <div v-show="result == 3" class="dialog-content">-->
<!--        <div class="tips">-->
<!--          <span class="my-waring">取消</span>订单，请输入取消原因-->
<!--        </div>-->
<!--        <el-input-->
<!--          v-model="remark"-->
<!--          rows="5"-->
<!--          type="textarea"-->
<!--          placeholder=""-->
<!--        />-->
<!--        <div class="tip-hit" v-if="tip">-->
<!--          <span class="tip">-->
<!--            <i class="el-icon-warning"></i>-->
<!--            该用户与<span style="font-weight: 700; color: #000">{{ tip }}</span>库中数据匹配，请复核后谨慎操作！-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->

      <div slot="footer">
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
        <el-button type="primary" @click="save" size="small">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 取消 -->
    <CancelOrder
        :visible.sync="cancel.visible"
        :orderNo="cancel.orderNo"
        @refresh="closePage"
    />
  </div>
</template>

<script>
import {
  handleReviewPassAPI,
  handleReviewCancelAPI,
  handleReviewRefuseAPI,
} from "./modules/api";
import DetailBase from "./detail-base.vue";
import DetailJiShen from "./detail-jishen.vue";
import AuditResult from "./modules/review-result.vue";
import MemberInfo from "@/views/review/order-list/modules/member-info.vue";
import { getReviewOrderDetailAPI } from "@/views/review/order-list/api";
import ConfirmOrder from "@/views/order/order-list/confirm-order.vue";
import CancelOrder from "@/views/order/order-list/cancel-order.vue";

export default {
  name: "ReviewOrderDetail",
  components: {
    CancelOrder,
    MemberInfo,
    DetailBase,
    DetailJiShen,
    AuditResult,
  },
  data() {
    return {
      dialogVisible: false,
      activeName: "1",
      detailInfo: {},
      result: "",
      content: "",
      remark: "",
      contactList: [],
      reviewPass: "",
      tip: "",
      cancel: {
        visible: false,
        orderNo: "",
      },
    };
  },

  watch: {
    activeName: {
      handler(newV, oldV) {
        if (this.activeName == 2) {
          this.$refs.jishen.getRiskReview();
        }
      },
    },
  },

  activated() {
    this.getEmitReviewOrderDetail();
  },

  methods: {
    goJS() {
      this.activeName = "2";
    },

    async getEmitReviewOrderDetail() {
      this.detailInfo = await getReviewOrderDetailAPI(this.$route.params.id);
    },

    async getReviewOrderDetail(obj) {
      this.detailInfo = obj;
    },

    handleResult(val) {
      this.hit();
      this.result = val;
      if (this.result === 1) {
        this.reviewPass = '';
        this.dialogVisible = true;
      } else if (this.result === 2) {
        this.content = '';
        this.dialogVisible = true;
      } else if (this.result === 3) {
        this.cancel.visible = true;
        this.cancel.orderNo = this.$route.params.id;
      }
    },
    // 撞库
    async hit() {
      let arr = [];
      const { rosterLevelList } = this.detailInfo;
      rosterLevelList.forEach((item) => {
        if (item == 2) {
          arr.push('黑名单');
        } else if (item == 1) {
          arr.push('白名单');
        }
      });
      this.tip = arr.join("、");
    },

    save() {
      this.dialogVisible = false;
      if (this.result == 1) {
        if (!this.reviewPass) {
          this.$alert("请填写备注!", "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
          this.dialogVisible = true;
          return;
        }
        let data = {
          orderNo: this.$route.params.id,
          remark: this.reviewPass,
        };
        handleReviewPassAPI(data).then(() => {
          this.$message.success("审核通过成功，即将关闭本页面...");
          setTimeout(() => {
            this.emitAwindow();
            window.close();
          }, 2000);
        });
      } else if (this.result == 2) {
        let data = {
          orderNo: this.$route.params.id,
          remark: this.content,
        };
        handleReviewRefuseAPI(data).then(() => {
          this.$message.success("拒绝成功，即将关闭本页面...");
          setTimeout(() => {
            this.emitAwindow();
            window.close();
          }, 2000);
        });
      }
      // else if (this.result == 3) {
      //   let data = {
      //     orderNo: this.$route.params.id,
      //     remark: this.remark,
      //   };
      //   handleReviewCancelAPI(data).then(() => {
      //     this.$message.success("订单取消成功，即将关闭本页面...");
      //     setTimeout(() => {
      //       this.emitAwindow();
      //       window.close();
      //     }, 2000);
      //   });
      // }
    },

    emitAwindow() {
      if (window.opener) {
        if (window.opener.getBpageList) {
          window.opener.getBpageList();
        } else {
          window.opener.frames[0].getBpageList();
        }
      }
    },

    closePage() {
      this.emitAwindow();
      window.close();
    },

  },
};
</script>

<style lang="scss" scoped>
.wrapper-detail {
  width: 100%;
  min-width: 1150px;
  background: #f5f7fa;
  padding: 20px;
  height: calc(100vh - 84px);
  max-height: calc(100vh - 84px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
}

// 统一的卡片样式
.member-card,
.content-card {
  border-radius: 12px;
  border: none;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 100%;
  flex-shrink: 0;

  ::v-deep .el-card__body {
    padding: 24px;
  }
}

.member-card {
  flex-shrink: 0;
}

// 内容卡片
.content-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  ::v-deep .el-card__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .detail-tabs {
    flex-shrink: 0;
    
    ::v-deep .el-tabs__header {
      margin: 0;
      background: #fafbfc;
      border-bottom: 1px solid #e4e7ed;
      padding: 0 24px;

      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
      }

      .el-tabs__nav {
        display: flex;
      }

      .el-tabs__item {
        font-size: 15px;
        font-weight: 500;
        color: #606266;
        padding: 0 24px;
        height: 50px;
        line-height: 50px;
        transition: all 0.3s ease;
        border-bottom: 2px solid transparent;
        margin-right: 8px;

        span {
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        i {
          font-size: 16px;
          transition: all 0.3s ease;
        }

        &:hover {
          color: #409EFF;
          
          i {
            color: #409EFF;
          }
        }

        &.is-active {
          color: #409EFF;
          font-weight: 600;
          border-bottom-color: #409EFF;
          
          i {
            color: #409EFF;
          }
        }
      }

      .el-tabs__active-bar {
        display: none;
      }
    }
  }

  .tab-content {
    padding: 24px 24px 120px 24px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;

      &:hover {
        background: #a8a8a8;
      }
    }
  }
}

.result-spacer {
  height: 100px;
  flex-shrink: 0;
}

// 审核结果区域
.result {
  position: fixed;
  left: 200px;
  bottom: 0;
  min-height: 80px;
  height: auto;
  width: calc(100% - 200px);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  z-index: 2999;
  padding: 20px 50px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08), 0 -2px 8px rgba(0, 0, 0, 0.04);
  border-top: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

// 对话框样式
::v-deep .el-dialog {
  border-radius: 12px;
  
  .el-dialog__header {
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 2px solid #f0f2f5;
    
    .el-dialog__title {
      font-size: 18px;
      font-weight: 700;
      color: #1a1e25;
    }
  }
  
  .el-dialog__body {
    padding: 24px;
  }
  
  .el-dialog__footer {
    padding: 16px 24px;
    background: #fafbfc;
    border-top: 1px solid #f0f2f5;
    
    .el-button {
      border-radius: 8px;
      padding: 10px 24px;
      font-weight: 600;
      transition: all 0.3s ease;
      
      &.el-button--primary {
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        
        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }
      }
    }
  }
}

.dialog-content {
  margin-top: 20px;

  .item {
    display: flex;
    margin: 15px 0;
    align-items: flex-start;

    & > span {
      &:first-child {
        white-space: nowrap;
        margin-right: 10px;
        color: #606266;
        font-weight: 500;
        font-size: 14px;
      }
    }

    &:nth-child(n + 2) {
      & > span {
        &:first-child {
          width: 100px;
          text-align: right;
        }

        &:last-child {
          flex: 1;
        }
      }
    }

    .tip {
      background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
      padding: 12px 16px;
      border-radius: 8px;
      font-weight: 600;
      border: 1px solid #fbc4c4;
      color: #e34d59;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #e34d59;
        font-size: 18px;
      }
    }
  }

  .bill-box {
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }
    
    .el-checkbox {
      margin-right: 0;
      
      ::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
        font-weight: 500;
      }

      ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        border-color: #409EFF;
        background-color: #409EFF;
      }

      ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        border-color: #ffffff;
      }
    }
  }

  .tips {
    margin: 10px 0 20px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
  
  .el-textarea {
    ::v-deep .el-textarea__inner {
      border-radius: 8px;
      border: 1.5px solid #E4E7ED;
      transition: all 0.3s ease;
      
      &:hover {
        border-color: #C0C4CC;
      }
      
      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
      }
    }
  }
}

.tip-hit {
  margin-top: 20px;
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 600;
  border: 1px solid #fbc4c4;
  color: #e34d59;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    color: #e34d59;
    font-size: 18px;
  }
}

.my-waring {
  color: #f56c6c;
  font-weight: 700;
  font-size: 20px;
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  padding: 8px 16px;
  border-radius: 8px;
  display: inline-block;
  border: 1px solid #fbc4c4;
}

.without-layout {
  .wrapper-detail {
    height: 100% !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
    background: #f5f7fa;
    gap: 0;

    .member-card {
      margin: 0;
      border-radius: 0;
      box-shadow: none;
      padding: 20px 24px 0;
      flex-shrink: 0;
      
      ::v-deep .el-card__body {
        padding: 0;
      }
    }

    .content-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      min-height: 0;
      overflow: hidden;

      ::v-deep .el-card__body {
        min-height: 0;
        overflow: hidden;
      }

      .tab-content {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 24px 24px 120px 24px;
        
        &::-webkit-scrollbar {
          width: 8px;
        }
        
        &::-webkit-scrollbar-track {
          background: #f5f7fa;
          border-radius: 4px;
        }
        
        &::-webkit-scrollbar-thumb {
          background: #c0c4cc;
          border-radius: 4px;
          
          &:hover {
            background: #a8abb2;
          }
        }
      }
    }
    
    .result {
      left: 0;
      width: 100%;
      padding: 20px 24px;
    }
    
    .result-spacer {
      height: 100px;
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .wrapper-detail {
    padding: 16px 16px 120px;
    gap: 16px;
  }
  
  .result {
    left: 0;
    width: 100%;
    padding: 20px 24px;
  }
}

@media (max-width: 768px) {
  .wrapper-detail {
    padding: 12px 12px 120px;
    min-width: auto;
    gap: 12px;
  }

  .member-card,
  .content-card {
    border-radius: 8px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }

  .content-card {
    .detail-tabs ::v-deep .el-tabs__header {
      padding: 0 16px;

      .el-tabs__item {
        padding: 0 16px;
        font-size: 14px;

        i {
          display: none;
        }
      }
    }

    .tab-content {
      padding: 16px 16px 120px 16px;
    }
  }
  
  .result {
    height: auto;
    padding: 16px;
    min-height: 80px;
  }
}
</style>
